var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownload = function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2.25a1 1 0 1 0-2 0v7.336L8.207 6.793a1 1 0 0 0-1.414 1.414l4.5 4.5.007.007a1 1 0 0 0 .697.286h.006c.272 0 .518-.11.697-.286l.008-.008 4.5-4.499a1 1 0 0 0-1.415-1.414L13 9.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 13h3.444a1 1 0 1 0 0-2H3a1.75 1.75 0 0 0-1.75 1.75v6A1.75 1.75 0 0 0 3 20.5h18a1.75 1.75 0 0 0 1.75-1.75v-6A1.75 1.75 0 0 0 21 11h-3.694a1 1 0 1 0 0 2h3.444v5.5H3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 15.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconDownload;